// ══════════════════════════════════════════════════════════════
// COMPASS – Management Company State Model
// ══════════════════════════════════════════════════════════════
import { ManagementCompanyDto } from '../../api/models/management-company-dto';

export interface ManagementCompanyState {
  companies: ManagementCompanyDto[];
  selectedCompanyId: string | null;
  loading: boolean;
  permissionsLoading: boolean;
  permissionsLoaded: boolean;
  error: string | null;
}

export const initialManagementCompanyState: ManagementCompanyState = {
  companies: [],
  selectedCompanyId: null,
  loading: false,
  permissionsLoading: false,
  permissionsLoaded: false,
  error: null,
};
